module.exports = {
    apiKey: "AIzaSyAFVNbj736qlssUeKFozCSKTNFD_fCptm0",
    authDomain: "gallery-pradarshak.firebaseapp.com",
    projectId: "gallery-pradarshak",
    storageBucket: "gallery-pradarshak.appspot.com",
    messagingSenderId: "1046443257817",
    appId: "1:1046443257817:web:498c30ace810066e4f33c8",
    measurementId: "G-P73DD9HB9L"
};
